import type {PropsWithChildren} from 'react'

export type GetPathFunc = (loc?: {country?: string; city?: string; tariff?: string}) => string

export type RedirectFunc = (path: string) => void

export type LinkComponentProps = PropsWithChildren<{
  to: string
  className?: string
}>

export type PathWithoutCountry = {
  country?: string
  city?: string
  tariff?: string
}

export type PathWithCountry = {
  country: string
  city?: string
  tariff?: string
}

export type Path = PathWithoutCountry | PathWithCountry

export const enum ModalId {
  COUNTRY_MODAL = 'country-modal',
  FULLSCREEN_MAP = 'fullscreen-map',
}

export type Brand = 'yandex' | 'yango'
